export const DATA_TABLE_LOADER = 'list-item-three-line';
